/* ------------------------------------------------------------
 * Maison Montrose — images en avance (18 septembre 2026)
 *
 * Toutes les images sous le premier écran sont en `loading="lazy"` : le
 * navigateur ne les demande qu'à l'approche de l'écran, d'où des cartes
 * beiges quand on descend vite. Une fois la page chargée (event `load`),
 * ce script les fait venir en avance, dans l'ordre de lecture, par petits
 * lots, en priorité basse : rien ne concurrence le premier écran, et quand
 * la visiteuse arrive sur une section, ses images sont déjà là.
 *
 * Sur ordinateur, toutes les images visibles de la page y passent. Sur
 * téléphone, quatre écrans devant la position courante, puis on recommence
 * à chaque défilement ; rien si la connexion est économe (saveData, 2G).
 * Les diapositives du héros ont leur propre règle (mon-hero-carrousel).
 * Revert = retirer le <script> dans layout/theme.liquid.
 * ------------------------------------------------------------ */

(function () {
  'use strict';

  var lien = navigator.connection || navigator.mozConnection || {};
  if (lien.saveData || /(^|[^3-5])2g/.test(lien.effectiveType || '')) return;

  var telephone = !!(window.matchMedia && window.matchMedia('(max-width: 760px)').matches);
  var PORTEE = telephone ? 4 : Infinity;     /* écrans devant la position courante */
  var LOT = telephone ? 2 : 4;               /* images lancées par tour */
  var PAUSE = telephone ? 350 : 180;         /* ms entre deux tours */

  var enCours = false;

  function candidats() {
    var h = window.innerHeight || 800;
    var liste = [];
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.monAvance) continue;
      if (!img.getAttribute('src') && !img.getAttribute('srcset') && !img.dataset.src) continue;
      if (img.complete && img.naturalWidth) { img.dataset.monAvance = '1'; continue; }
      if (img.closest('[data-mhc-slide]')) continue;
      if (!img.getClientRects().length) continue;      /* masquée (menu, tiroir) */
      var top = img.getBoundingClientRect().top;
      if (top > h * PORTEE) continue;
      liste.push({ img: img, top: top });
    }
    liste.sort(function (a, b) { return a.top - b.top; });
    return liste.map(function (o) { return o.img; });
  }

  function tourner() {
    var liste = candidats();
    if (!liste.length) { enCours = false; return; }
    for (var i = 0; i < liste.length && i < LOT; i++) {
      var img = liste[i];
      img.dataset.monAvance = '1';
      if (img.dataset.src) {                     /* snippets/mon-image-differee */
        if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
        img.setAttribute('src', img.dataset.src);
        if (img.dataset.alt) img.alt = img.dataset.alt;
        delete img.dataset.srcset; delete img.dataset.src; delete img.dataset.alt; delete img.dataset.monDiffere;
      }
      if (!img.getAttribute('fetchpriority')) img.setAttribute('fetchpriority', 'low');
      img.loading = 'eager';
    }
    setTimeout(tourner, PAUSE);
  }

  function demarrer() {
    if (enCours) return;
    enCours = true;
    if ('requestIdleCallback' in window) window.requestIdleCallback(tourner, { timeout: 2000 });
    else setTimeout(tourner, 300);
  }

  function armer() {
    setTimeout(demarrer, telephone ? 600 : 400);
    if (telephone) {
      var dernier = 0;
      window.addEventListener('scroll', function () {
        var t = Date.now();
        if (t - dernier < 500) return;
        dernier = t;
        demarrer();
      }, true);
    }
  }

  if (document.readyState === 'complete') armer();
  else window.addEventListener('load', armer, { once: true });
})();
